import * as React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { PaymentMethod } from 'api/common/constants'
import { PurchaseCredixResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { PositionSimplified } from 'api/common/types'
import { purchaseCredixAPI } from 'api/purchase'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'
import { getPositionLabel } from 'utilities/resources/options'
import { numberFormat } from 'utilities/typeUtility'
import { PositionInfo } from 'utilities/resources/formItemValues'

type StateValue = {
  contractPositions?: PositionSimplified[]
  showPositions?: PositionInfo[]
}

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const stateValue = React.useMemo(() => (location.state ?? {}) as StateValue, [location])
  const { contractPositions, showPositions } = stateValue
  const [cardInfo, setCardInfo] = React.useState<PurchaseCredixResponse>()
  const [isSpinningSubmit, setIsSpinningSubmit] = React.useState(false)
  const positionNumbers = React.useMemo(() => contractPositions?.map((data) => data.positionNumber) ?? [], [contractPositions])
  const successUrl = new URL('/aubeQuestDealPurchaseForCreditCardConfirm', window.location.href).href
  const failureUrl = new URL('/positionContract', window.location.href).href

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else if (!contractPositions) {
      navigate('/positionContract')
    } else {
      purchaseCredixAPI({ positions: contractPositions }, (status, response) => {
        if (status === Status.Success) {
          setCardInfo(response)
          loginData.setPurchasePositionData({ positionNumbers, amount: response.amount })
        } else {
          navigate('/positionContract')
        }
      })
    }
  }, [navigate, contractPositions, positionNumbers])
  return (
    <>
      <Header title="AUBEクエストディール購入" />
      <main>
        <section className="mx-4 my-5">
          <div>
            お申込みのポジション数分のAUBEクエストディールを購入ください。
            <br />
            <span className="text-danger">ここで入力されたAUBEクエストID（ゲームのID）とコネクターIDが連結され報酬計算の対象となります。</span>
            <br />
            報酬取得権利確定課金の計算対象はこのポジション及び、このポジションから始まるパーソナルグループとなります。
            <br />
            サブポジションはポジション管理画面より、個別で決済する事も可能です。
          </div>
          <div className="mt-5">
            <h3 className="fw-bold">決済ポジション</h3>
            {showPositions?.map((position, index) => (
              <div key={index}>
                <div className="fw-bold mt-4">{getPositionLabel(position.positionNumber)}</div>
                <div className="mt-2">コネクターID : {position.positionId}</div>
                <div className="mt-2">AUBEクエストID : {position.atemQuestId}</div>
                <hr className="mt-4 my-2" />
              </div>
            ))}
          </div>
          <div className="mt-5">
            <div>AUBEクエストディール</div>
            <div className="fw-bold mt-1">価格&nbsp;&nbsp;&nbsp;¥{numberFormat(cardInfo?.amount)}（税込）</div>
          </div>
          <div className="mt-5">
            <form method="post" action="https://secure.credix-web.co.jp/cgi-bin/credit/order.cgi" acceptCharset="shift_jis" onSubmit={() => setIsSpinningSubmit(true)}>
              <input type="hidden" name="clientip" value={process.env.REACT_APP_CREDIX_CLIENT_IP} />
              <input type="hidden" name="money" value={cardInfo?.amount ?? 0} />
              <input type="hidden" name="telno" value={cardInfo?.telNumber ?? ''} />
              <input type="hidden" name="email" value={cardInfo?.email ?? ''} />
              <input type="hidden" name="sendpoint" value={cardInfo?.uuid ?? ''} />
              <input type="hidden" name="success_url" value={successUrl} />
              <input type="hidden" name="success_str" value="AUBEクエストコネクター登録完了画面へ戻る" />
              <input type="hidden" name="failure_url" value={failureUrl} />
              <input type="hidden" name="failure_str" value="AUBEクエストコネクターへ戻る" />
              <Button type="submit" variant="primary" className="w-100 py-4" disabled={isSpinningSubmit || !cardInfo}>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isSpinningSubmit} />
                購入する
              </Button>
            </form>
          </div>
          <div className="mt-5 text-center">
            <Button variant="link" onClick={() => navigate('/paymentSelect', { state: { contractPositions, showPositions, previousScene: PaymentMethod.CreditCard } })}>
              支払い方法を変更する
            </Button>
          </div>
          <div className="mt-5 text-center">
            <Button variant="link" href="/positionContract">
              戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
